import { put, call, take, fork } from 'redux-saga/effects'
import { teamsMemberDeleteService } from '../../api/teams'
import { teamsMemberDeleteSuccess } from 'src/reducers/teams/action'
import { TEAMS_MEMBER_DELETE } from 'src/reducers/teams/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* teamsMemberDeleteFlow(payload) {
  try {
    const { teamsId, memberId, callback } = payload

    const response = yield call(teamsMemberDeleteService, teamsId, memberId)

    yield put(teamsMemberDeleteSuccess(payload))
    callback(response)
    yield put(operationSuccess())
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* teamsMemberDeleteWatcher() {
  while (true) {
    const action = yield take(TEAMS_MEMBER_DELETE)
    const { payload } = action

    yield fork(generalSaga, teamsMemberDeleteFlow, payload)
  }
}
